import React, { Component } from "react";
import styles from "./controlPoints.module.scss";
import { MapConsumer, MapContainer, TileLayer, Marker, Circle } from "react-leaflet";
import { withGeocoder } from "../../../shared/containers/containerGeocoder";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import TopRightMapControl from "../../LayerMapCotrol/TopRightMapControl";
import BaseLayerMapControl from "../../LayerMapCotrol/BaseLayerMapControl";
import L from "leaflet";
import { ControlPointIcon } from "./ControlPointIcon";
import geocoderService from "../../../shared/services/geocoderService";

class MapCreateControlPoint extends Component {
  onMoveMarker(target) {
    const { onLocationChange } = this.props;

    geocoderService
      .reverse({ lat: target._latlng.lat, lon: target._latlng.lng })
      .then((result) => {
        onLocationChange(target._latlng, result.data.address);
      })
      .catch(() => {});
  }

  render() {
    const { mapBaseLayer, zoom, isViewCustomMap, selectedGeocoderSearch, controlPoint } = this.props;

    if (controlPoint === null) return null;

    const bounds =
      selectedGeocoderSearch !== null && selectedGeocoderSearch.boundingbox.length > 0 ? selectedGeocoderSearch.boundingbox : null;

    const height = window.innerHeight > 800 ? 400 : 250;

    const svgIcon = L.divIcon({
      html: `<div>${ControlPointIcon.getIcon("black")}</div>`,
      className: "svg-icon",
      iconSize: [26, 26],
      iconAnchor: [6, 25],
    });

    return (
      <div style={{ height: `${height}px` }}>
        <MapContainer
          key={`${controlPoint.id} ${mapBaseLayer.name} ${zoom} isSideBarOpen} ${bounds} ${isViewCustomMap}`}
          center={[controlPoint.latitude, controlPoint.longitude]}
          zoom={bounds === null ? 17 : 12}
          maxZoom={mapBaseLayer.maxZoom}
          minZoom={3}
          crs={mapBaseLayer.crs}
          zoomControl={true}
          attributionControl={false}
          doubleClickZoom={true}
          scrollWheelZoom={true}
          dragging={true}
          animate={true}
          easeLinearity={0.35}
          className={styles.mapWrapper}
          bounds={bounds}
        >
          <MapConsumer>
            {(map) => {
              if (bounds !== null) {
                map.fitBounds(new L.latLngBounds([new L.latLng(bounds[0], bounds[2]), new L.latLng(bounds[1], bounds[3])]));
              }

              return null;
            }}
          </MapConsumer>

          {mapBaseLayer.url.map((_url, index) => {
            return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
          })}

          <Marker
            draggable={true}
            icon={svgIcon}
            eventHandlers={{
              moveend: (e) => {
                this.onMoveMarker(e.target);
              },
            }}
            position={[controlPoint.latitude, controlPoint.longitude]}
          ></Marker>

          {controlPoint.radius > 0 ? (
            <Circle
              key={`${controlPoint.radius} ${controlPoint.latitude} ${controlPoint.longitude}`}
              center={[controlPoint.latitude, controlPoint.longitude]}
              radius={Number(controlPoint.radius)}
            />
          ) : null}

          {this.props.children}
        </MapContainer>

        <div className={styles.mapBaseLayerControlContainer}>
          <BaseLayerMapControl />
        </div>
      </div>
    );
  }
}

export default withGeocoder(withMapControl(React.memo(MapCreateControlPoint)));
